import {Component, Input, OnInit} from '@angular/core';
import {compareValidator} from 'src/app/Shared/directives/common-form-validator.directive';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {validateAllFormFields} from 'src/app/Shared/utilities/helpers';
import {AuthService} from "../../../Shared/services/api-services/auth.service";
import {TokenService} from "../../../Shared/services/app-services/token.service";
import {NotificationService} from "../../../Shared/services/app-services/notification.service";
// import {PasswordStrengthValidator} from 'src/app/Shared/utilities/strong-password';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {

  // @Input() passToken: string;

  state = {
    post: false
  };

  public updatePasswordForm: FormGroup;

  static updatePasswordControl = () => {
    return {
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      password_confirmation: ['', [Validators.required, compareValidator('password')]],
      token: ['']
    };
  }

  constructor(private _FB: FormBuilder, private _router: Router, private route: ActivatedRoute,
              private _tokenService: TokenService,
              private _notificationService: NotificationService,
              private _authService: AuthService) {
    this.updatePasswordForm = this._FB.group(UpdatePasswordComponent.updatePasswordControl());
  }

  ngOnInit(): void {
    if(!this.route.snapshot.paramMap.get('token')) {
      this.goBack();
    }
  }

  public goBack(): void {
    this._router.navigate(['/login']);
  }

  public submit() {
    if (this.updatePasswordForm.invalid) {
      return validateAllFormFields(this.updatePasswordForm);
    }
    this.state.post = true;
    const payload = this.updatePasswordForm.value;
    console.log(payload);
    this._authService.setPassword({...payload, token: this.route.snapshot.paramMap.get('token') || null})
      .subscribe(res => {
      this.state.post = false;
      console.log(res);
      this._router.navigate(['login']); // redirect
      }, err => {
      console.error('Error ', err);
      this.state.post = false;
      this._notificationService.showError(err.error.message || 'Unable to reset password');
    });
  }
}
